import React from 'react';
import { ExternalLink } from 'shared/ui/external-link/external-link';

const PLAIN_URL_PATTERN =
  'https?:\\/\\/[^\\s<>"\'`]+(?:\\([^\\s<>"\'`]*\\))*[^\\s<>"\'`.,;:!?)]';
const LINK_REGEX = new RegExp(
  `\\[([^\\]]+)\\]\\((${PLAIN_URL_PATTERN})\\)|(${PLAIN_URL_PATTERN})`,
  'gi'
);

/**
 * Converts plain URLs and markdown links ([label](url)) into clickable <a>.
 * If no URLs found, returns the original string unchanged.
 */
export const linkifyText = (text: string): React.ReactNode => {
  if (!text || typeof text !== 'string') return text;
  const regex = new RegExp(LINK_REGEX.source, LINK_REGEX.flags);
  const matches = Array.from(text.matchAll(regex));
  if (matches.length === 0) return text;

  const result: React.ReactNode[] = [];
  let lastIndex = 0;
  let key = 0;

  matches.forEach(match => {
    const fullMatch = match[0];
    const label = match[1];
    const url = match[2];
    const plainUrl = match[3];
    const href = url || plainUrl;
    const linkText = label || href;
    const index = match.index ?? lastIndex;

    if (index > lastIndex) result.push(text.slice(lastIndex, index));
    if (!href) return;

    result.push(
      <ExternalLink key={`link-${key++}`} href={href}>
        {linkText}
      </ExternalLink>
    );
    lastIndex = index + fullMatch.length;
  });

  if (lastIndex < text.length) result.push(text.slice(lastIndex));

  return <>{result}</>;
};
